import { useRef } from 'react';
import { Content } from '@builder.io/sdk-react';
import type { BuilderContent as BuilderEntry } from '@builder.io/sdk-react';
import useAnchorScroll from './hooks/useAnchorScroll';

interface BuilderContentProps {
  content: BuilderEntry;
  apiKey: string;
  model?: string;
  headerSelector?: string;
}

export default function BuilderContent({
  content,
  apiKey,
  model = 'section',
  headerSelector = '#bio-top-menu',
}: BuilderContentProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useAnchorScroll(containerRef, headerSelector);

  return (
    <div ref={containerRef}>
      <Content content={content} apiKey={apiKey} model={model} />
    </div>
  );
}
